import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaxData = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.3934 25.848L12.4441 26.5547L13.1508 21.6053L25.8788 8.87734C27.0503 7.70576 28.9498 7.70576 30.1214 8.87734C31.293 10.0489 31.293 11.9484 30.1214 13.12L17.3934 25.848Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 2.74866C7 2.33444 7.33579 1.99866 7.75 1.99866H16.25C16.6642 1.99866 17 2.33444 17 2.74866V5.24866C17 5.66287 16.6642 5.99866 16.25 5.99866H7.75C7.33579 5.99866 7 5.66287 7 5.24866V2.74866Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 3.99866H21C22.1046 3.99866 23 4.89409 23 5.99866",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 25.9987V29.9987C23 31.1032 22.1046 31.9987 21 31.9987H3C1.89543 31.9987 1 31.1032 1 29.9987V5.99866C1 4.89409 1.89543 3.99866 3 3.99866H7",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 11.9987H17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 17.9987H11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTaxData);
export default ForwardRef;
